export const STEPS = {
  IMPORT_COA: "IMPORT_COA",
  ADD_DETAILS: "ADD_DETAILS",
  MAP_DATA_CONNECTIONS: "MAP_DATA_CONNECTIONS",
  MAP_CATEGORIES: "MAP_CATEGORIES",
  REVIEW: "REVIEW",
} as const;

export type STEPS_TYPE = (typeof STEPS)[keyof typeof STEPS];

export const STEPS_BREADCRUMBS: Array<{
  name: string;
  step: STEPS_TYPE;
  no: number;
}> = [
  { name: "Import CoA", step: STEPS.IMPORT_COA, no: 1 },
  { name: "Add details", step: STEPS.ADD_DETAILS, no: 2 },
  { name: "Map data connections", step: STEPS.MAP_DATA_CONNECTIONS, no: 3 },
  { name: "Map categories", step: STEPS.MAP_CATEGORIES, no: 4 },
  { name: "Review", step: STEPS.REVIEW, no: 5 },
];
